import React, { FC } from 'react';
import { useTranslate } from '@refinedev/core';
import { Col, Layout as AntdLayout, Row } from 'antd';
import { Header } from '../../public-header';
import { Footer } from '../../footer';
import { OffLayoutArea } from '../../offLayoutArea';
import Container from '../../container';
import { getFullYear } from '../../../../utils/date';
import layoutStyles from '../Layout.module.scss';
import styles from './public.module.scss';
import { Link } from 'react-router-dom';
import { CompanyLogo } from '../../../company-logo';
import AccessibilityToolbar from '../../../AccessibilityToolbar';

type LayoutProps = React.PropsWithChildren<{
    sidebar?: React.ReactNode;
}>;

export const Layout: FC<LayoutProps> = ({ children, sidebar = <></> }) => {
    const t = useTranslate();

    return (
        <AntdLayout className={layoutStyles.pageWrapper}>
            <AccessibilityToolbar />
            <AntdLayout className={layoutStyles.innerPageWrapper}>
                <AntdLayout.Content>
                    <Container max={1200} padX={0}>
                        <div className={styles.contentWrapper}>
                            <div className={styles.content}>
                                <Header />
                                <main className={styles.mainContent}>
                                    {children}
                                </main>
                            </div>
                            <aside className={styles.sidebar}>
                                {sidebar ?? null}
                            </aside>
                        </div>
                    </Container>
                    <OffLayoutArea />
                </AntdLayout.Content>
                <Footer>
                    <Container max={1200} padX={0}>
                        <Row gutter={[0, 0]}>
                            <Col xs={24} lg={12}>
                                <div className={styles.footerContent}>
                                    <CompanyLogo
                                        href="/"
                                        src="/images/moz.svg"
                                        alt={t(
                                            'pages.login.state_enterprise_state_expert_center_of_the_ministry_of_health_of_ukraine_description'
                                        )}
                                        width={100}
                                        height={48}
                                        className={styles.logo}
                                    />
                                    <div className={styles.footerMenu}>
                                        <Link
                                            to="/"
                                            className={styles.footerMenuItem}
                                        >
                                            {t('menu.home', 'Головна')}
                                        </Link>
                                        <Link
                                            to="https://www.dec.gov.ua/populyarni-pytannya/"
                                            target="_blank"
                                            className={styles.footerMenuItem}
                                        >
                                            {t(
                                                'menu.useful_information',
                                                'Корисна інформація'
                                            )}
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} lg={12}>
                                {/*<div className={styles.footerCopy}>*/}
                                {/*    © {getFullYear()} {t('all_rights_reserved')}*/}
                                {/*</div>*/}
                            </Col>
                        </Row>
                    </Container>
                </Footer>
            </AntdLayout>
        </AntdLayout>
    );
};
